// extracted by mini-css-extract-plugin
export default {"document_main":"DocumentationMain_document_main__6x4rn"};